import React from 'react';
import {useHistory} from 'react-router-dom';
import '../CSS/IdCard.css';
import { motion} from 'framer-motion';
import LeftArrow from '../Images/leftArrow.png';
import Refresh from '../Images/refresh.png';
import Loading from '../Components/Loading';
import { pageTransition, pageStyle, pageVariants } from '../Components/Animations/Transition';
import {getUrl} from '../Functions.js';

function IdCard(props) {
  const history  = useHistory();
  if(localStorage.getItem("loggedIn")!=="true"){
    history.push("/opening");
  }
  
  const cookie = localStorage.getItem("cookie");
  const [id, setId] = React.useState("");
  const [loading, setLoading] = React.useState(true);
  
  const showIdMessage1 = "Forgot your Id-Card?" 
  const showIdMessage2 = "Show this screen."

  var update = false;
  const loadingHeight = "100vh";

  const options = {
    method : 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ 
      cookies:cookie
    }) 
  }
  function back(){
    history.push("/home");
  }

  function fetchData(){
    if(localStorage.getItem("loggedIn")!=="true"){
      history.push("/opening");
    }
    setLoading(true);
    fetch(getUrl() + 'idCard', options)
      .then(response => response.json()).then(
        data =>{
        if(data.retry===true){
            console.log("retrying...");
            fetchData();
        }else{    
            setId(data.idCard);
            update = false;
            setLoading(false);
        }
        }
      );
  }
  
  React.useEffect(() => {
    fetchData();
  },[]);

  return (
    <motion.div className="IdCardMain"
    initial="initial"
    animate="in"
    exit="out"
    style={pageStyle}
    variants={pageVariants}
    transition={pageTransition}>
      <div className="TopIdCard">
        <img src={LeftArrow} alt="back" className="BackIdCard" onClick={()=>{
          back();
        }} color="#000000" />
        <div ></div>
        <img src={Refresh} alt="refresh" className="RefreshIdCard" onClick={()=>{
          if(update!==true){
            update = true;
            fetchData();
          }}} color="#000000"/>
      </div>
      {loading===true?<Loading height={loadingHeight} color="#ffffff"/>:
        <div className="BottomIdCard">
          <div className="MessageIdCard">
            {showIdMessage1}
          </div>
          <div className="MessageIdCard">
            {showIdMessage2}
          </div>
          <div 
            className="IdCard"
            dangerouslySetInnerHTML={{__html: id}}
            />
          
        </div>
      }
    </motion.div>
  );

}



export default IdCard;